import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_DISABLE_GEOLOCATION_GUEST_SIGN_FORM = createFcmDetails('disable_geolocation_guest_sign_form', {
	owner: 'supporters pack',
	context: 'petition page',
	description:
		'If true, geolocation for guests is disabled, meaning the localization fields (e.g. country, city, ...) will not be pre-filled.',
	import: false,
});
